import { getEndpoint } from "@api-routes/endpoint";
import { TSearchServiceListQuery } from "@features/AccountDetails/interface/TSearchServiceListQuery";
import { objectToQueryQuestionMark } from "@utils/url";

const ACCOUNTS_MS_NAME = "accounts";
export const GET_ACCOUNT_LIST_ROUTE = `${getEndpoint(ACCOUNTS_MS_NAME)}accounts/paginated`;

export const getServiceApiRoute = (serviceId: number) => `${getEndpoint(ACCOUNTS_MS_NAME)}services/${serviceId}`;

export const getSearchServiceListRoute = (query: TSearchServiceListQuery) =>
    `${getEndpoint(ACCOUNTS_MS_NAME)}services/paginated${objectToQueryQuestionMark(query)}`;

export const GET_SUBSCRIPTION_LIST_ROUTE = `${getEndpoint(ACCOUNTS_MS_NAME)}subscriptions`;

export const getTerminationReasonsRoute = (serviceGroup: string) =>
    `${GET_SUBSCRIPTION_LIST_ROUTE}/termination-reasons?accountType=B2C&displayable=true&serviceGroup=${serviceGroup}`;
